export default function processDataFromLocalStorage() {
  // Retrieve the JSON data from localStorage
  const jsonData = localStorage.getItem('UpdatedDataArray'); 

  if (!jsonData) {
    console.log('No data found in localStorage');
    return [];
  }

  // Parse the JSON data into an array in the desired format
  const rawData = JSON.parse(jsonData);

  // Collect unique parent categories
  const uniqueParentCategories = [...new Set(rawData.map(item => item['Category (per property)']))];

  // Create a data array with unique parent categories
  const processedData = uniqueParentCategories.map(category => ({
    id: category,
    name: category,
    quality: NaN,
    parent: undefined,
  }));

  // Process the rest of the data
  rawData.forEach((item, index) => {
    // Adjust this condition as needed
    processedData.push({
      id: `Property${index + 1}`,
      name: item['Property'],
      quality: parseFloat(item['Quality (per value)']),
      parent: item['Category (per property)'],
    });
  });

  return processedData;
}